export default __webpack_public_path__ + "a116b52e1d498d73ec9f12ac4ea29f21.png";